import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Col, Image, Row, Table } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'

export default function FlushDoor() {
    let image = useLocation().state.image

    return (
        <div>
            <Row className='mx-0' style={{ marginBottom: '61px' }}>
                <Col md={{ order: 'last' }} className='position-relative w-100 col-md-6 col-12 product-page-image-section mt-5 mt-md-0'>
                    <Image className='product-page-image position-absolute ' src={image} />
                </Col>
                <Col md={{ order: 'first' }} className='col-md-6 col-12'>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }} className='mb-4'>ABOUT THE<br /> PRODUCT</h3>
                    </AnimationOnScroll>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <p align='left' style={{ fontSize: '1.3em' }}>
                            Similar to Block Boards, Flush doors are produced by sandwiching selected hardwood timbers between the layers
                            of plies. This gives the Flush Doors a uniform structural strength, thickness and stability. The dimensional
                            stability and perfect bonding of the Flush Door is achieved through the vacuum pressure binding process. As
                            flush doors don’t split or rot, they don’t require periodic refinishing, the flush doors are great at
                            resisting scratches, stains and stand atmospheric humidity.
                            <br /><br />
                            The flush doors qualify various impact, slamming and shock resistance tests which makes them great for
                            doors. The flush doors are sleek and elegant with MR & BWP grades that makes it all the more useful for
                            both indoor and outdoor applications. Their simplicity in design and affordable pricing make them a
                            desirable purchase. The flush doors are widely used in the application of doors and shutters for homes,
                            offices and apartments.
                        </p>
                    </AnimationOnScroll>
                </Col>
            </Row>
            <Row className='mx-0 justify-content-between' style={{ marginTop: '109px' }}>
                <Col md={2} className='d-flex align-items-center'>
                    <h3 style={{ fontWeight: '800', color: '#FCCD37', textAlign: 'start' }}>Product Specification</h3></Col>
                <Col md={9}>
                    <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                        <Table responsive>
                            <thead style={{ color: '#FFF' }}>
                                <tr>
                                    <th className='text-start'>TEST</th>
                                    <th className='text-start'>ISI SPECIFIED VALUE</th>
                                    <th className='text-start'>RESULT OBTAINED</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontWeight: '500' }}>
                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Dimension</td>
                                    <td className='text-start'>Length,Width-+5mm<br />
                                        Thickness-+1mm</td>
                                    <td className='text-start'>Within Limit</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Squareness</td>
                                    <td className='text-start'>Deviation not more than 1mm on a length of 500mm</td>
                                    <td className='text-start'>Deviation below 1mm</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>General Flatness</td>
                                    <td className='text-start'>Twist, Cupping, Warping shall not exceed 0.6mm</td>
                                    <td className='text-start'></td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Local Planeless</td>
                                    <td className='text-start'>Depth of deviation at any point to be less than 0.5mm</td>
                                    <td className='text-start'>Within limits</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Impact Indentation Test</td>
                                    <td className='text-start'>Depth of Indentation not to exceed 0.2mm</td>
                                    <td className='text-start'>Within limits</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Edge Loading Test</td>
                                    <td className='text-start'>Deﬂection of edge with max. To be less than 5mm</td>
                                    <td className='text-start'>Within limits</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Shock Resistance Test</td>
                                    <td className='text-start'>No visible defect after test</td>
                                    <td className='text-start'>No visible damage</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Buckling Test</td>
                                    <td className='text-start'>{`Initial deﬂection -<50mm,`}<br />
                                        {`residual deﬂection -<50mm`}</td>
                                    <td className='text-start'>Within limits</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Slamming Test</td>
                                    <td className='text-start'>No visible damage after test</td>
                                    <td className='text-start'>No visible damage</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Misuse Test</td>
                                    <td className='text-start'>No deformation after test</td>
                                    <td className='text-start'>No deformation</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Verifying Humidity Test</td>
                                    <td className='text-start'>No Visible warping, twisting or delamination</td>
                                    <td className='text-start'>No such defects observed</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>End Immersion Test</td>
                                    <td className='text-start'>	No delamination at the end</td>
                                    <td className='text-start'>	No delamination</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Knife Test</td>
                                    <td className='text-start'>Min.Pass Standard</td>
                                    <td className='text-start'>Excellent</td>
                                </tr>

                                <tr style={{ backgroundColor: '#FFC700' }}>
                                    <td className='text-start'>Glue Adhesion Test</td>
                                    <td className='text-start'>No delamination</td>
                                    <td className='text-start'>No delamination</td>
                                </tr>

                                <tr style={{ color: '#FFF' }}>
                                    <td className='text-start'>Screw Withdrawal Test</td>
                                    <td className='text-start'>Load to window screw to be more than 1000 N</td>
                                    <td className='text-start'>{`Load – >1000 N`}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </AnimationOnScroll>
                </Col>
            </Row>
        </div>
    )
}
